import React from 'react';
import { MDXProvider } from '@mdx-js/react';
import { getMermaidConfig } from './src/utils/mermaid-config';

// Initialize Mermaid
const initMermaid = () => {
  if (typeof window !== 'undefined' && window.mermaid) {
    window.mermaid.initialize(getMermaidConfig());

    // Add 'mermaid' class to all 'language-mermaid' code blocks
    document.querySelectorAll('code.language-mermaid').forEach((el) => {
      // Find or create the parent container
      const container = el.parentElement;
      if (container) {
        container.classList.add('mermaid');
        // Move the mermaid content out of the <code> block
        const content = el.textContent;
        container.dataset.graphDefinition = content;
        container.textContent = content;
      }
    });

    window.mermaid.init(undefined, '.mermaid');

    document.querySelectorAll('.mermaid').forEach((el) => {
      el.setAttribute('role', 'img');
      if (!el.getAttribute('aria-label')) {
        el.setAttribute('aria-label', 'Mermaid diagram');
      }
    });
  }
};

// Trust All Scripts
const trustAllScripts = () => {
  const scriptNodes = document.querySelectorAll('.load-external-scripts script, .mermaid script');

  for (let i = 0; i < scriptNodes.length; i += 1) {
    const node = scriptNodes[i];
    const s = document.createElement('script');
    s.type = node.type || 'text/javascript';

    if (node.attributes.src) {
      s.src = node.attributes.src.value;
    } else {
      s.innerHTML = node.innerHTML;
    }

    document.getElementsByTagName('head')[0].appendChild(s);
  }
};

// Wrap the root element to provide MDX context
export const wrapRootElement = ({ element }) => {
  return <MDXProvider>{element}</MDXProvider>;
};

// Initialize Mermaid when the page loads
export const onInitialClientRender = () => {
  initMermaid();
  trustAllScripts();
};

export const onRouteUpdate = () => {
  if (typeof window !== 'undefined' && window.mermaid) {
    window.mermaid.initialize(getMermaidConfig());

    // Handle both .mermaid and code.language-mermaid
    document.querySelectorAll('code.language-mermaid').forEach((el) => {
      const container = el.parentElement;
      if (container) {
        container.classList.add('mermaid');
        const content = el.textContent;
        container.dataset.graphDefinition = content;
        container.textContent = content;
      }
    });

    // Re-render all mermaid diagrams with current theme
    window.mermaid.init(undefined, '.mermaid');

    document.querySelectorAll('.mermaid').forEach((el) => {
      el.setAttribute('role', 'img');
      if (!el.getAttribute('aria-label')) {
        el.setAttribute('aria-label', 'Mermaid diagram');
      }
    });
  }
  trustAllScripts();
};

export const onServiceWorkerUpdateReady = () => {
  window.location.reload(true);
};

// Disable default scrollToTop on / page to stabilize search experience
export const shouldUpdateScroll = ({
  routerProps: { location },
}) => {
  const { pathname, hash } = location;

  // Preserve hash anchor scrolling
  if (hash) {
    return true;
  }

  // list of routes for the scroll-to-top-hook
  const scrollToTopRoutes = ['/'];
  // if the new route is NOT part of the list above, scroll to top (0, 0)
  if (!scrollToTopRoutes.includes(pathname)) {
    return [0, 0];
  }

  return false;
};
